<template>
  <div>
    <n-bar title="消费明细" :top="true" :right-show="true" :on-click-home="home"/>
    <div style="background: #fff;">
      <div class="top">
        <div
          style="height: 40px;line-height: 40px;padding: 0 10px;font-size:14px;span-align: center;border-bottom: 1px solid #F5F6F8;">
          近30天消费记录
        </div>
        <div style="display: flex;align-items: center;margin: 0 10px;border-bottom: 1px solid #F5F6F8;">
          <div style="height: 40px;line-height: 40px; flex: 1.5;">时间与场地</div>
          <div style="height: 40px;line-height: 40px; flex: 1.5;">记录</div>
          <div style="height: 40px;line-height: 40px; flex: 1;">结果</div>
        </div>
      </div>
      <list-loading style="height: calc(100% - 85px);margin-top: 72px;" ref="orderList" :data.sync="orderList"
                    :page.sync="orderPage" :limit.sync="orderLimit" @loadlist="getOrderData" :threshold="100"
                    :is-show-mod="true">
        <div slot="list" style="display: flex;align-items: center;margin: 0 10px;padding: 7px 0;"
             v-for="(item, index) in orderList" :key="index">
          <div style="flex: 1.5;display: flex;flex-direction: column;justify-content: center;">
            <div>{{item.addressName}}</div>
            <div style="color: #9B9B9B;font-size: 12px;margin-top: 5px;">{{item.payTime}}</div>
          </div>
          <div style="flex: 1.5;display: flex;flex-direction: column;justify-content: center;">
            <nut-price :price="item.totalMoney" :decimalDigits="2" :needSymbol="true" :thousands="true"
                       style="zoom: 0.9;margin-bottom: 5px;"/>
            <div style="color: #9B9B9B; font-size: 12px;">启动设备</div>
          </div>
          <div style="flex: 1;">
            <span style="color: #1afa29;">{{item.paid == 1 ? '启动成功' : '未启动'}}</span>
          </div>
        </div>
      </list-loading>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeviceOrderRecord',
  data () {
    return {
      user: {},
      orderPage: 1,
      orderLimit: 15,
      orderList: []
    }
  },
  mounted () {
    this.user = this.$api.user
    this.getOrderData()
  },
  methods: {
    home () {
      let deviceId = localStorage.getItem('deviceId')
      this.$router.push(`/device/DeviceUse?deviceId=${deviceId}`)
    },
    getOrderData () {
      let startDate = new Date()
      startDate.setDate(startDate.getDate() - 30)
      let startTime = this.$util.formatDate.format(startDate, 'yyyy/MM/dd')
      startTime = startTime.replace(/-/g, '/')
      let endTime = this.$util.formatDate.format(new Date(), 'yyyy/MM/dd')
      endTime = endTime.replace(/-/g, '/')
      let time1 = new Date(startTime + ' 00:00:00')
      let time2 = new Date(endTime + ' 23:59:59')
      this.$api.post({
        url: '/device/api/device/order/list',
        data: {
          merId: this.$api.merId,
          uid: this.user.uid,
          startTime: time1.getTime() / 1000,
          endTime: time2.getTime() / 1000,
          page: this.orderPage,
          limit: this.orderLimit
        },
        loading: false
      }).then(res => {
        this.$refs.orderList.setRes(res)
      })
    }
  }
}
</script>

<style scoped>
  .top {
    position: fixed;
    top: 30px;
    width: 100%;
    background: #fff;
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/home/DeviceOrderRecord.vue